import request from '@/http/request'

export const getConfigQuery = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/system/config/query`, params, { noSpin: true })
}
export const getOrderSearch = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/order/listReturnOrder`, params)
}
export const getOrderExport = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/order/exportReturnOrders2`, params)
}
export const uploadBatchQueryExcel = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/order/uploadBatchQueryExcel`, params, {
    hiddenError: true
  })
}
